import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice d'heures supplémentaires";
const DESCRIPTION =
  "Calculatrice d'heures supplémentaires. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "overtime calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/overtime-calculator/";

function OvertimeCalculator() {
  const [hoursWorked, setHoursWorked] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [result, setResult] = useState(null);

  const calculate = () => {
    if (!hoursWorked || !hourlyRate) return;
    const hours = parseFloat(hoursWorked);
    const rate = parseFloat(hourlyRate);
    const regularHours = Math.min(hours, 40);
    const overtimeHours = Math.max(0, hours - 40);
    const regularPay = regularHours * rate;
    const overtimePay = overtimeHours * rate * 1.5;
    const totalPay = regularPay + overtimePay;

    setResult({
      regularHours,
      overtimeHours,
      regularPay: regularPay.toFixed(2),
      overtimePay: overtimePay.toFixed(2),
      totalPay: totalPay.toFixed(2)
    });
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Calculez rapidement votre remuneration totale en distinguant les heures regulieres des heures supplementaires. Saisissez vos heures travaillees et votre taux horaire pour obtenir le detail complet de votre paie.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Heures travaillées:</label>
                    <input type="number" value={hoursWorked} onChange={(e) => setHoursWorked(e.target.value)} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Taux horaire:</label>
                    <input type="number" value={hourlyRate} onChange={(e) => setHourlyRate(e.target.value)} className="form-control" />
                  </div>
                  <button onClick={calculate} className="btn btn-success w-100">Calculer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="bg-light p-3 rounded">
                    <h3>Résultats</h3>
                    <table className="table table-bordered table-sm">
                      <tbody>
                        <tr>
                          <td>Heures régulières:</td>
                          <td>{result.regularHours}h</td>
                        </tr>
                        <tr>
                          <td>Paiement régulier:</td>
                          <td>${result.regularPay}</td>
                        </tr>
                        <tr>
                          <td>Heures supplémentaires:</td>
                          <td>{result.overtimeHours}h</td>
                        </tr>
                        <tr>
                          <td>Paiement heures supp:</td>
                          <td>${result.overtimePay}</td>
                        </tr>
                        <tr style={{ fontWeight: "bold" }}>
                          <td>Paiement total:</td>
                          <td>${result.totalPay}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment lire le resultat</h3></div>
              <div className="info-section-body">
                <p>La calculatrice separe les heures regulieres et les heures supplementaires, puis affiche le paiement correspondant a chaque partie. Vous obtenez aussi le total estime pour la periode saisie.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Regle utilisee dans ce calcul</h3></div>
              <div className="info-section-body">
                <p>Par defaut, l'outil applique un seuil de 40 heures et un coefficient de 1,5 pour les heures supplementaires. Verifiez votre convention collective locale pour ajuster l'interpretation du resultat.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil pratique</h3></div>
              <div className="info-section-body">
                <p>Conservez un suivi hebdomadaire de vos heures reelles pour comparer vos bulletins de paie. Cela permet de detecter rapidement un ecart de calcul et de le corriger avec justificatifs.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OvertimeCalculator;